import {ValidateMicroSoftToken} from "../../Services";

export const ThirdPartiesEnum = {
  Microsoft: {
    key: 1,
    value: "microsoft",
    color: "#0167b9",
    icon: "fab fa-windows",
    path: "/oauth/web/adfs/authhandler",
    providerKey: 'microsoft_azure_sso',
    routeKey:"microsoft" ,
    validationApi: ValidateMicroSoftToken,
  },
};
